<template>
    <div>
        <app-title text="Asignación de tarea" />
        <b-button variant="primary" @click="startCreateTask"><i class="fa fa-plus"></i> Crear tarea</b-button>
        <app-task-filters
            @filter="onFilter"
            @clean="resetFilters"
        />
        <app-task-list
            :data="tasks"
            @see-notes="seeNotes"
            @create-note="startCreateNote"
            @add-watcher="startAddWatchers"
            @delete-task="startDeleteTask"
            :on-change-page="onChangePage"
            @sort="onSort"
        />

        <!-- INICIO popUp's -->
        <app-pop-up title="Formulario de tarea" id="task-form" :onClose="cleanForm" size="large">
            <div slot="body">
                <app-task-form
                    :on-save="onSave"
                />
            </div>
            <div slot="buttons">
                 <button class="btn btn-confirm" @click="$bus.$emit('task-form.save')"> Guardar</button>
            </div>
        </app-pop-up>

        <app-pop-up title="Notas de la tarea" id="comments-task">
            <div slot="body">
                <app-notes-task v-if="selectTask"
                    :data="selectTask.notes"
                />
            </div>  
        </app-pop-up>

        <app-pop-up title="Agregar nota de la tarea" id="add-comment-task" :onClose="cleanNoteForm">
            <div slot="body">
                <app-add-note-task v-if="selectTask"
                    id="add-comment-task"
                    :task="selectTask" 
                    :on-save="onSaveNote"
                />
            </div>
            <div slot="buttons">
                 <button class="btn btn-confirm" :disabled="inProgress" @click="saveNote"> Guardar</button>
            </div> 
        </app-pop-up>

        <app-pop-up title="Agregar observador a la tarea" id="add-watcher-task" :onClose="cleanWatcherForm">
            <div slot="body">
                <app-assign-watcher v-if="selectTask"
                    id="add-watcher-task"
                    :task-id="selectTask.id"
                    :on-save="onAssignWatchers"
                />
            </div>
            <div slot="buttons">
                 <button class="btn btn-confirm" :disabled="inProgress" @click="addWatchers"> Asignar</button>
            </div> 
        </app-pop-up>
        
        <app-pop-up title="Confirmación" id="delete-task">
            <div slot="body"><h2>¿Esta seguro que desea eliminar esta tarea?</h2></div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteTask(selectTask)"><i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación</button>
            </div>
        </app-pop-up>
        <!-- FIN popUp's -->
    </div>
</template>
<script>
import TaskList from './AssignmentTaskList/AssignmentTaskList.vue';
import TaskForm from './AssignmentTaskForm/AssignmentTaskForm.vue';
import TaskFilters from './AssignmentTaskFilters/AssignmentTaskFilters.vue';
import NotesTask from '../NotesTask/NotesTaskList/NotesTask.vue';
import AddNoteTask from '../NotesTask/AddNoteTask/AddNoteTask.vue';
import tasksRepository from '../../../../repositories/tasks.repository.js';
import AssignWatcher from '.././WatchersTask/AssignWatcher/AssignWatcher.vue';
export default {
    components: {
        appTaskList: TaskList,
        appTaskForm: TaskForm,
        appNotesTask: NotesTask,
        appAddNoteTask: AddNoteTask,
        appTaskFilters: TaskFilters,
        appAssignWatcher: AssignWatcher
    },

    data(){
        return {
            tasks: '',
            page: 1,
            selectTask: '',
            sort: {
                sortBy: 'due_date',
                sortDir: 'asc'
            },
            filters: {}
        }
    },

    methods: {
        loadCreatedTasks(){
            const tr = Object.assign({}, tasksRepository);
            const payload = {...this.filters, status: 'open', sortBy: this.sort.sortBy, sortDir: this.sort.sortDir }
            tr.getTasksByUser(this.user.id, payload, this.page)
            .then(data => {
                this.tasks = data;
            })
            .catch(error=> toastr.error('Error al cargar las tareas del usuario'));
        },
        onChangePage(page){
            this.page = page;
            this.loadCreatedTasks();
        },
        onFilter(filters){
            this.filters = filters;
            this.loadCreatedTasks();
        },
        resetFilters(filters){
            this.filters = {};
            this.page = 1;
            this.loadCreatedTasks();
        },
        startCreateTask(){
            this.$bus.$emit('task-form.open');
        },
        cleanForm() {
            this.$bus.$emit('task-form.clean');
        },
        onSave() {
            this.$bus.$emit('task-form.close');
            this.loadCreatedTasks();
        },
        saveNote(){
            this.$bus.$emit('add-comment-task.save');
        },
        onSaveNote() {
            this.$bus.$emit('add-comment-task.close');
            this.loadCreatedTasks();
        },
        cleanNoteForm() {
            this.$bus.$emit('add-comment-task.clean');
        },
        cleanWatcherForm() {
            this.$bus.$emit('add-watcher-task.clean');
        },
        startCreateNote(task){
            this.selectTask = task;
            this.$bus.$emit('add-comment-task.open');
        },
        startAddWatchers(task){
            this.selectTask = task;
            this.$bus.$emit('add-watcher-task.open');  
        },
        startDeleteTask(task){
            this.selectTask = task;
            this.$bus.$emit('delete-task.open');  
        },
        deleteTask(task){
            const tr = {...tasksRepository};
            tr.deleteTask(task.id)
            .then(data => {
                if (data.status) {
                    toastr.success(data.msg);
                    this.loadCreatedTasks();
                    this.$bus.$emit('delete-task.close');
                } else {
                    toastr.error(data.msg);
                }
            })
            .catch(error => {
                toastr.error('No se pudo borrar la tarea');
            });
        },
        deleteUser(user) {
                const ur = Object.assign({}, userRepository);
                ur
                    .deleteUser(user.id)
                    .then(data => {
                        if (data.status) {
                            toastr.success(data.msg);
                            this.loadUsers();
                            this.$bus.$emit('user-remove.close');
                        } else {
                            toastr.error(data.msg);
                        }
                    })
                    
            },
        addWatchers(){
            this.$bus.$emit('add-watcher-task.save');
        },
        onAssignWatchers() {
            this.$bus.$emit('add-watcher-task.close');
            this.loadCreatedTasks();
        },
        seeNotes(task){
            this.selectTask = task;
            this.$bus.$emit('comments-task.open');
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadCreatedTasks();
        },
        deleteComment(payload) {
            const task = this.tasks.data.find(task => task.id === payload.taskId);

            if(!task) return;

            task.detailsShowing = true;

            task.notes = task.notes.filter(note => note.id !== payload.noteId);
        }
    },

    created(){
        this.loadCreatedTasks();

        this.$bus.$on('task-note.delete', this.deleteComment);
    }
}
</script>
